import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import Index from "./pages/Index";
import ArticlePage from "./pages/ArticlePage";
import CustomNIPPage from "./pages/CustomNIPPage";
import MagazinePage from "./pages/MagazinePage";
import NeurodiversityPage from "./pages/NeurodiversityPage";
import { NIP19Page } from "./pages/NIP19Page";
import NotFound from "./pages/NotFound";

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/neurodiversity" element={<NeurodiversityPage />} />
        <Route path="/article/:dTag" element={<ArticlePage />} />
        <Route path="/nip/:dTag" element={<CustomNIPPage />} />
        <Route path="/magazine/:dTag" element={<MagazinePage />} />
        {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
        <Route path="/:nip19" element={<NIP19Page />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;